export default "__VITE_ASSET__b2008555__"